import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FieldArray, Fields, FormSection, getFormSyncErrors } from 'redux-form';
import { propArrayStr, propShape, propStr, } from '../../../../../../../../helpers/custom-prop-types';
import { proffitSearchAccountBillingInformationValidate } from '../../../../../../../../validate/custom/proffit_search/account_billing_information';
import AccountBillingInformationFieldArray from './AccountBillingInformationFieldArray';
import AccountBillingInformationFields from './AccountBillingInformationFields';
const AccountBillingInformationField = (props) => {
    const { admin, enableDomains, form } = props;
    const { billingInformationArray: billingInformationArrayError } = useSelector((state) => getFormSyncErrors(form)(state));
    const fieldsProps = useMemo(() => ({
        billingInformation: {
            addObject: { email: '' },
            names: ['email'],
        },
    }), []);
    return (_jsx(FieldArray, { addObject: fieldsProps.billingInformation.addObject, component: AccountBillingInformationFieldArray, error: billingInformationArrayError, form: form, name: 'billingInformation', render: (renderProps) => (_jsx(FormSection, Object.assign({ name: renderProps.field }, { children: _jsx(Fields, { admin: admin, component: AccountBillingInformationFields, enableDomains: enableDomains, index: renderProps.index, names: fieldsProps.billingInformation.names, onClickDelete: renderProps.onClickDelete, validate: proffitSearchAccountBillingInformationValidate.email }, renderProps.field) }), renderProps.field)) }));
};
AccountBillingInformationField.propTypes = {
    admin: propShape(),
    enableDomains: propArrayStr().isRequired,
    form: propStr().isRequired,
};
AccountBillingInformationField.defaultProps = {
    admin: undefined,
};
export default AccountBillingInformationField;
